import { render } from "./MissedVideoCallNotification.vue?vue&type=template&id=07c0d4d0&scoped=true"
import script from "./MissedVideoCallNotification.vue?vue&type=script&lang=js"
export * from "./MissedVideoCallNotification.vue?vue&type=script&lang=js"

import "./MissedVideoCallNotification.vue?vue&type=style&index=0&id=07c0d4d0&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c0d4d0"]])

export default __exports__